module.exports = __webpack_public_path__ + "static/img/score.95062ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/student-smart/score.png
// module id = C7MC
// module chunks = 1